import Mediator from './Mediator';

const CLASS_TYPE = ['multi', '1on1']

class ClassDetail extends Mediator {
  constructor(rawData) {
    super(rawData);

    if (rawData instanceof Mediator) {
      return this;
    }

    this.setVersion('v1', [
      'absentFlag', 'cState', 'cancelFlag', 'classID', 'className', 'classStudentCount',
      'classStudentList', 'classTeacherList', 'costRule', 'endDateTime', 'feeType',
      'lessonCheckinedCount', 'lessonCount', 'lessonList', 'maxStudentNumber', 'startDateTime',
      'total_price', 'unit_price',
    ], {});

    this.setVersion('v2', [
       "id",
        "cName",
        "cType",
        "feeType",
        "totalPrice",
        "unitPrice",
        "startDate",
        "endDate",
        "currencyUnit",
        "totalQuantity",
        "maxStudentsNumber",
        "cAddress",
        "costRule",
        "costAlertRange",
        "absentFlag",
        "cancelFlag",
        "cState",
        "classCode",
        "cReateTime",
        "cRemark",
        "cSchool",
        "usedLessonTimes",
        "usedLessonHours",
        "totalHours",
    ], {
      relatedAPIs: ['g_clss_tch_stdt']
    });

    this.setVersion('v3', ['id', 'cName', 'cType']);

    this.setVersion('v4', [
      'absentFlag', 'cancelFlag', 'classID', 'className', 'costRule',
      'feeType', 'has_lesson', 'maxStudentsNumber', 'studentCount',
      'teacherCount', 'teacherList', 'totalHours', 'totalPrice',
      'totalQuantity', 'unitPrice', 'usedLessonHours', 'usedLessonTimes',
    ], {});

    this.__schema = {
      id: { alias: ['classID', 'id', 'cId'], },
      address: { alias: ['cAddress'], },
      name: { alias: ['className', 'cName'] },
      state: { alias: ['cState'] },
      type: { alias: ['classType', 'cType'] },
      feeType: { alias: ['feeType'] },
      studentCount: { alias: ['classStudentCount', 'studentCount'] },
      studentList: { alias: ['classStudentList', 'studentList'] },
      teacherCount: { alias: ['teacherCount'] },
      teacherList: { alias: ['classTeacherList', 'teacherList'] },
      absentFlag: { alias: ['absentFlag'] },
      cancelFlag: { alias: ['cancelFlag'] },
      costRule: { alias: ['costRule'] },
      endDateTime: { alias: ['endDateTime'] },
      startDateTime: { alias: ['startDateTime'] },

      endDateTime: { alias: ['endDateTime'] },
      startDateTime: { alias: ['startDateTime'] },

      endTime: { alias: ['endTime'] },
      startTime: { alias: ['startTime'] },

      totalHours: { alias: ['totalHours'] },
      totalQuantity: { alias: ['totalQuantity'] },
      totalPrice: { alias: ['totalPrice'] },

      usedLessonHours: { alias: ['usedLessonHours'] },
      usedLessonTimes: { alias: ['usedLessonTimes'] },

      hasLesson: { alias: ['hasLesson'] },
      lessonCheckinedCount: { alias: ['lessonCheckinCount'] },
      lessonCount: { alias: ['lessonCount'] },
      lessonList: { alias: ['lessonList'] },
      maxStudentNumber: { alias: ['maxStudentNumber', 'maxStudentsNumber'] },
      totalPrice: { alias: ['totalPrice', 'total_price'] },
      unitPrice: { alias: ['unitPrice', 'unit_price'] },
      createTime: { alias: ['cReateTime'], },
      remark: { alias: ['cRemark'], },
      schoolID: { alias: ['cSchool'] },
      classCode: { alias: ['classCode'] },
      costAlertRange: { alias: ['costAlertRange' ] },
      currencyUnit: { alias: ['currencyUnit' ] },
      eachLessonDuration: { alias: ['eachLessonDuration' ] },
    }

    return this.create();
  }

  getClassTypeStr() {
    let {
      type,
    } = this.__privateData;

    if (typeof type !== 'undefined') {
      return CLASS_TYPE[type];
    } else {
      return
    }
  }

  getStudentIdList() {
    let {
      studentIdList,
      studentList = [],
    } = this.__privateData;

    if (Array.isArray(studentIdList)) {
      return studentIdList;
    }

    return studentList.map((student)=>{
      return student.id;
    });
  }

  getTeacherIdList() {
    let {
      teacherIdList,
      teacherList = [],
    } = this.__privateData;

    if (Array.isArray(teacherIdList)) {
      return teacherIdList;
    }

    return teacherList.map((teacher)=>{
      return teacher.id;
    });

  }

}

export default ClassDetail;



// WEBPACK FOOTER //
// ./src/mediators/ClassDetail.js